import React from 'react';

export default function CounterCard({ counter }) {
  return (
    <div className="counter">
      <div className="counter-h">
        <span className="counter-n">COUNTER {String(counter.n ?? '').padStart(2, '0')}</span>
        {counter.source && <span className="counter-src">SOURCE · {counter.source.toUpperCase()}</span>}
      </div>
      {counter.title && <h4 className="counter-title">{counter.title}</h4>}
      {counter.body && <p className="counter-body">{counter.body}</p>}
      {counter.implication && (
        <div className="counter-imp">
          <span className="imp-label">IMPLICATION</span>
          <span className="imp-text">"{counter.implication}"</span>
        </div>
      )}
    </div>
  );
}
